// @flow
import classnames from 'classnames';
import { get } from 'lodash';
import React from 'react';

import { Scrollable } from 'Components/frameworks/scrollable/Scrollable';
import { getInstalmentPrice } from 'Components/utils/price/price.util';
import responsive from 'Components/utils/responsive/Responsive';
import { scrollToElement } from 'Components/utils/scroll/scrollToElement';
import ReactAppContext from 'Context/ReactAppContext';

type monthBlock = {
  hasPrice: boolean,
  id: number,
  name: string,
  price?: FormattedPrice,
  shortName: string,
  year: number,
};

type Props = {
  blocks: monthBlock[],
  onChangeMonth: number => void,
  currentMonth: number,
  cmsPrice: {
    format: {
      from: string,
    },
  },
};

export class PriceCalendarMonths extends React.Component<Props> {
  static contextType = ReactAppContext;
  initialPosition: number;

  constructor(props: Props) {
    super(props);

    (this: any).isMonthSelected = this.isMonthSelected.bind(this);
  }

  renderMonthsContainer() {
    return (
      <div>
        <Scrollable
          childrenWrapperClassNames="flex"
          childrenWrapperClassNames="PriceCalendarMonths-scrollableContainer flex"
          className="PriceCalendarMonths-months relative items-end -mt-5 mb-4"
          elementWidth={82}
          initialPosition={this.initialPosition}
          navPosition="center"
        >
          {this.renderMonths()}
        </Scrollable>
      </div>
    );
  }

  renderMonths() {
    return (get(this.props, 'blocks') || []).map(this.renderMonthBlock, this);
  }

  renderMonthBlock(block: monthBlock, index: number) {
    if (this.isMonthSelected(block.id)) {
      this.initialPosition = index;
    }
    return (
      <div
        className="PriceCalendarMonths-monthContainer mx-1 relative align-top"
        key={`container${index}`}
      >
        {this.renderMonthButton(block)}
        {this.isMonthSelected(block.id) && (
          <div className="PriceCalendarMonths-monthsArrowContainer" />
        )}
      </div>
    );
  }

  renderMonthButton(block: monthBlock) {
    const isMonthSelected = this.isMonthSelected(block.id);
    const buttonClass = classnames(
      'PriceCalendarMonths-month rounded-tiny p-0 font-bold text-black text-center uppercase',
      {
        'PriceCalendarMonths-month--selected': isMonthSelected,
      },
    );
    const nameClass = classnames('PriceCalendarMonths-monthName', {
      'PriceCalendarMonths-monthName--selected': isMonthSelected,
    });
    const monthName = this.getMonthName(block.name, block.shortName, isMonthSelected);
    const onClick = isMonthSelected ? null : this.selectMonth.bind(this, block.id);

    return (
      <button className={buttonClass} type="button" onClick={onClick}>
        <div className="PriceCalendarMonths-monthInnerContainer flex flex-col items-center justify-center leading-one">
          <div>
            <span className={nameClass}>{monthName}</span>
            <span> </span>
            <span className="PriceCalendarMonths-year">{isMonthSelected && block.year}</span>
          </div>
          {block.hasPrice && (
            <span>
              <span className="PriceCalendarMonths-monthFrom">
                {this.props.cmsPrice.format.from}
              </span>
              <span> </span>
              <span className="PriceCalendarMonths-monthPrice">
                {getInstalmentPrice(block.price, this.context.locale)}
              </span>
            </span>
          )}
        </div>
      </button>
    );
  }

  selectMonth(blockId: number) {
    this.props.onChangeMonth(blockId);
    !this.isDesktop() && scrollToElement('.PriceCalendarMonths', 100);
  }

  getMonthName(long: string, short: string, isMonthSelected: boolean) {
    if (isMonthSelected && this.isDesktop()) {
      return long;
    }
    return short;
  }

  isMonthSelected(id: number) {
    return id === this.props.currentMonth;
  }

  isDesktop() {
    return get(this.props, 'responsive.isDesktop', false);
  }

  render() {
    return <div className="bg-gray-lighter">{this.renderMonthsContainer()}</div>;
  }
}

export default responsive(PriceCalendarMonths);
